module.exports = __webpack_public_path__ + "img/ico-upload-cloud.4f1a1abb.svg";